import { render, staticRenderFns } from "./ExtraFeatures.vue?vue&type=template&id=967a80c0&scoped=true"
import script from "./ExtraFeatures.vue?vue&type=script&lang=js"
export * from "./ExtraFeatures.vue?vue&type=script&lang=js"
import style0 from "./ExtraFeatures.vue?vue&type=style&index=0&id=967a80c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967a80c0",
  null
  
)

export default component.exports